import {h} from "../../_snowpack/pkg/preact.js";
import ActivityIndicator from "../ActivityIndicator.js";
export default function BigInput({value, onChange, placeholder, loading, style}) {
  return /* @__PURE__ */ h("div", {
    class: `
    flex space-between w-full p-4 rounded-md
    bg-gray-200 dark:bg-gray-600
    text-black dark:text-white
    ${style ?? ""}
  `
  }, /* @__PURE__ */ h("input", {
    class: "w-4 h-8 flex-grow text-xl font-semibold bg-gray-200 dark:bg-gray-600",
    type: "text",
    value,
    onInput: (e) => typeof onChange === "function" && onChange(e.target.value),
    placeholder
  }), loading && /* @__PURE__ */ h(ActivityIndicator, {
    size: "large"
  }));
}
